"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tooltip.default;
  }
});

var _Tooltip = _interopRequireDefault(require("./Tooltip"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Tooltip/index.js
// module id = 822
// module chunks = 0